module.exports = __webpack_public_path__ + "img/point-right--white.09dd2283.svg";